<div (mouseleave)="mouseLeaveEvent()" id="map" class="map"></div>
